import NewQuestionModal from './NewQuestionModal'
import QuizReport from './QuizReport'
import StartStatusModal from './StartStatusModal'
import PauseStatusModal from './PauseStatusModal'
import DeleteQuestionModal from './DeleteQuestionModal'

export default QuizReport
export {
    NewQuestionModal,
    StartStatusModal,
    PauseStatusModal,
    DeleteQuestionModal,
}
